import type { SeriesRecord } from '@/components/Chart/types/chartData';
import type { ExtendedSeriesOptionsType, SeriesContext } from '@/components/Chart/types/highcharts';
import { formatPriceValue } from '@/utils/formatPriceValue';

export type TimeSeriesPointCustom = {
  timeRef?: string;
  timezone?: string;
  transactionDate?: number;
  periodAbs?: string;
  decimalPlaces: number;
};
export type TimeSeriesPoint = {
  x: number | undefined;
  y: number;
  custom?: TimeSeriesPointCustom;
};

export type BuildChartSeriesOptions = {
  name: string;
  id: string;
  color?: string;
  timeSeriesPoints: TimeSeriesPoint[] | SeriesRecord[];
  context: SeriesContext;
  visible?: boolean;
  isDaily?: boolean;
};
export const buildChartRangeSeries = ({
  name,
  id,
  timeSeriesPoints,
  context
}: BuildChartSeriesOptions): ExtendedSeriesOptionsType => ({
  data: timeSeriesPoints,
  type: 'arearange',
  lineWidth: 0,
  zIndex: -1,
  linkedTo: ':previous',
  name,
  id,
  custom: {
    ...context
  }
});

export const buildChartLineSeries = ({
  name,
  id,
  timeSeriesPoints,
  context,
  visible = true,
  isDaily = false
}: BuildChartSeriesOptions): ExtendedSeriesOptionsType => ({
  type: 'line',
  name,
  data: timeSeriesPoints,
  id,
  visible,
  connectNulls: !isDaily,
  marker: {
    radius: 1,
    symbol: 'circle'
  },
  gapSize: 10,
  lastVisiblePrice: {
    label: {
      formatter(this, value: number) {
        return formatPriceValue(context.decimalPlaces, value);
      }
    }
  },
  color: context.color,
  showInNavigator: true,
  custom: {
    hideName: Boolean(name),
    ...context
  }
});
